const l = {
  name: "Cctv",
  dimensions: { width: 40, height: 31 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 31.3" style="enable-background:new 0 0 40 31.3;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25,5.1c0,0.6-0.4,1-1,1s-1-0.4-1-1c0-0.6,0.4-1,1-1S25,4.6,25,5.1z"/>
		<path class="st0" d="M26.4,0l2.8,7.5l0,0l2.1,5.6l-1.9,0.7l1.4,3.8l-4.7,1.7l1.5,4H34v-6h6v14h-6v-6h-8L24.1,20l-4.7,1.7L18,17.9
			l-9.4,3.4l-0.7-1.9l-3.7,1.4l-2.7-7.5l1.5-0.5l-2-0.9L0,9.6L26.4,0z M10.3,14.4L8.4,15l1.4,3.8L28.6,12l-1.4-3.8L10.3,14.4z
			 M5.4,14l-1.5,0.5l1.4,3.7l1.9-0.7L6,14.2L5.4,14z M3,10.6L8.1,13l1.5-0.5l17-6.2l-1.4-3.8L3,10.6z M19.9,17.3l0.7,1.9l7.5-2.7
			l-0.7-1.9L19.9,17.3z M36,19.3v10h2v-10H36z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Cctv
};
